<template>
  <div>
    <div class="row align-items-center mb-1 p-2 border border-primary rounded">
      <div class="col-6 col-md-2 my-1" @click="isVisibleModal = true" style="cursor: pointer;">
        <a-icon type="eye" class="mr-1" />
        {{ data.church_name || moment(data.updated_at).format('MM/DD/YY') }}
      </div>
      <div class="col-6 col-md-2">
        <template v-if="!empty(data.amount)">
          <p>Cards Included</p>
          {{ separateNumber(data.amount) }}
        </template>
      </div>
      <div class="col-12 col-md-4">
        <img v-if="!empty(data.proof)" :src="data.proof" alt="back" class="mh-200p w-auto cursor-pointer" @click="viewImage(data.proof, 'Proof')" />

        <div class="row" v-else>
          <div class="col-12 col-sm-6">
            <img :src="getFrontCardUrl" alt="front" class="w-100 my-1 my-sm-0 mr-sm-1 cursor-pointer" @click="viewImage(getFrontCardUrl, 'Card Front')" />
          </div>
          <div class="col-12 col-sm-6">
            <img :src="getBackCardUrl" alt="back" class="w-100 cursor-pointer" @click="viewImage(getBackCardUrl, 'Card Back')" />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-2 text-md-center my-1">
        <a-button v-if="['Proof Ready', 'Proof Sent'].includes(data.status)" size="large" type="primary" class="text-center p-2" ghost @click="doAction('review')">Review and Approve</a-button>
        <a-button v-if="data.status === 'Shipped'" size="large" type="primary" class="text-center p-2" ghost @click="doAction('re-order')">Re-Order These Cards</a-button>
      </div>
      <div class="col-12 col-md-2 text-md-right my-1 d-flex flex-column align-items-end">
        <span v-text="data.status" />
        <a
          class="d-block"
          v-if="data.status === 'Shipped'"
          :href="`${shipper[data.shipper]}${data.tracking}`"
          target="_blank"
          rel="noopener noreferrer"
          v-text="`${data.shipper} - ${data.tracking}`"
        />
      </div>
    </div>
    <a-modal v-model="isVisibleModal" title="Card Order Detail" centered :footer="null" :destroyOnClose="true" :closable="true" :maskClosable="true" style="width: 100%; max-width: 80%;">
      <div class="card-item-detail">
        <div v-if="!empty(data.church_logo)">
          <span class="mr-2">Logo: </span>
          <img :src="data.church_logo" alt="Logo" class="mh-100p" />
        </div>
        <div v-if="!empty(data.proof)" class="my-1">
          <span class="mr-2">Proof: </span>
          <img :src="data.proof" alt="proof" class="mh-200p" />
        </div>
        <div v-if="!empty(data.other_file)">
          <span class="mr-2">Other file: </span>
          <a :href="data.other_file" target="_blank" rel="noopener noreferrer">{{ data.other_file }}</a>
        </div>
        <div v-if="!empty(data.pastors_name)">
          <span class="mr-2">Pastors Name: </span>
          <span>{{ data.pastors_name }}</span>
        </div>
        <div v-if="!empty(data.church_name)">
          <span class="mr-2">Church Name: </span>
          <span>{{ data.church_name }}</span>
        </div>
        <div v-if="!empty(data.church_email)">
          <span class="mr-2">Church Email: </span>
          <span>{{ data.church_email }}</span>
        </div>
        <div v-if="!empty(data.church_phone)">
          <span class="mr-2">Church Phone: </span>
          <span>{{ data.church_phone }}</span>
        </div>
        <div v-if="!empty(data.website)">
          <span class="mr-2">Website: </span>
          <a :href="data.website" target="_blank" rel="noopener noreferrer">{{ data.website }}</a>
        </div>
        <div v-if="!empty(data.service_times)">
          <span class="mr-2">Service Times: </span>
          <span>{{ data.service_times }}</span>
        </div>
        <div v-if="!empty(data.proofs_email)">
          <span class="mr-2">Proofs Email: </span>
          <span>{{ data.proofs_email }}</span>
        </div>
        <div v-if="!empty(data.notes)">
          <span class="mr-2">Notes: </span>
          <span>{{ data.notes }}</span>
        </div>
        <div v-if="!empty(data.amount)">
          <span class="mr-2">Cards Included: </span>
          <span>{{ separateNumber(data.amount) }}</span>
        </div>
        <div class="border-bottom border-info w-100 my-1" />
        <span class="mr-2">Card Address: {{ getCardAddress }}</span>
        <span class="mr-2">Shipping Address: {{ getShippingAddress }}</span>
      </div>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment';
import { get, find, toInteger } from 'lodash';
import { empty, separateNumber } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    cardsSources: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isVisibleModal: false,
  }),
  computed: {
    ...mapGetters(['shipper']),
    getBackCardUrl() {
      return get(
        find(get(this.cardsSources, 'back'), item => item.id === toInteger(this.data.card_back)),
        'url',
      );
    },
    getFrontCardUrl() {
      return get(
        find(get(this.cardsSources, 'front'), item => item.id === toInteger(this.data.card_front)),
        'url',
      );
    },
    getCardAddress() {
      let address = '';
      if (!empty(this.data.card_address)) {
        address += `${this.data.card_address} - `;
      }
      if (!empty(this.data.card_address2)) {
        address += `${this.data.card_address2} - `;
      }
      if (!empty(this.data.card_city)) {
        address += `${this.data.card_city} - `;
      }
      if (!empty(this.data.card_state)) {
        address += `${this.data.card_state} - `;
      }
      if (!empty(this.data.card_zipcode)) {
        address += `${this.data.card_zipcode}`;
      }
      return address;
    },
    getShippingAddress() {
      let address = '';
      if (!empty(this.data.shipping_address)) {
        address += `${this.data.shipping_address} - `;
      }
      if (!empty(this.data.shipping_address2)) {
        address += `${this.data.shipping_address2} - `;
      }
      if (!empty(this.data.shipping_city)) {
        address += `${this.data.shipping_city} - `;
      }
      if (!empty(this.data.shipping_state)) {
        address += `${this.data.shipping_state} - `;
      }
      if (!empty(this.data.shipping_zipcode)) {
        address += `${this.data.shipping_zipcode}`;
      }
      return address;
    },
  },
  methods: {
    moment,
    empty,
    separateNumber,
    doAction(type) {
      this.$emit('onAction', [
        type,
        this.data,
        {
          cardBackUrl: this.getBackCardUrl,
          cardFrontUrl: this.getFrontCardUrl,
          proofUrl: this.data.proof,
        },
      ]);
    },
    viewImage(url, title) {
      this.$emit('onOpenImage', { url, title });
    },
  },
};
</script>
